import './ThSort.scss';
import Component from './ThSort.js';
export default Component;
